
import Vue, { PropType } from "vue";
import { TenantUser, Website } from "@/models";
import BaseInputForm from "@/components/BaseInputForm.vue";
import BaseArrayCheckbox from "@/components/BaseArrayCheckbox.vue";
import BaseSubmitButton from "@/components/BaseSubmitButton.vue";
import BaseCancelButton from "@/components/BaseCancelButton.vue";

export type DataType = {
  name: string;
  mail: string;
  websiteIds: Array<string>;
};

export default Vue.extend({
  name: "TenantUserEditor",

  components: {
    BaseInputForm,
    BaseArrayCheckbox,
    BaseSubmitButton,
    BaseCancelButton
  },

  props: {
    tenantUser: Object as PropType<TenantUser>,
    websites: Array as PropType<Array<Website>>
  },

  data(): DataType {
    return {
      name: "",
      mail: "",
      websiteIds: []
    };
  },

  computed: {
    isEdited(): boolean {
      return (
        this.tenantUser.name !== this.name ||
        this.tenantUser.mail !== this.mail ||
        this.tenantUser.websites?.length !== this.websiteIds.length ||
        this.tenantUser.websites
          .map(w => this.websiteIds.includes(w.id || ""))
          .includes(false)
      );
    },

    canSubmit(): boolean {
      return !!this.name && !!this.mail && (!this.tenantUser || this.isEdited);
    }
  },

  watch: {
    tenantUser: function(n: TenantUser) {
      this.name = n.name || "";
      this.mail = n.mail || "";
      this.websiteIds = n.websites?.map(w => w.id || "") || [];
    }
  },

  methods: {
    saveTenantUser(): void {
      if (!this.canSubmit) return;
      this.$emit(
        "save-tenant-user",
        new TenantUser({
          name: this.name,
          mail: this.mail,
          websites: this.websites
        })
      );
    }
  }
});
